import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styles from './step-start.module.scss';
import { businessStore } from 'entities/index';
import { CircleImage, UniversalImage } from 'shared/ui';

interface IStepStart {
  onSelectService: () => void;
  onSelectEmployee: () => void;
}

const ScissorsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <line x1="20" y1="4" x2="8.12" y2="15.88" />
    <line x1="14.47" y1="14.48" x2="20" y2="20" />
    <line x1="8.12" y1="8.12" x2="12" y2="12" />
  </svg>
);

const PersonIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const StepStartComponent: React.FC<IStepStart> = ({
  onSelectService,
  onSelectEmployee,
}) => {
  const point = businessStore.pointHeaderData;
  const servicesCount = businessStore.servicesList?.length;
  const employeesCount = businessStore.employeesWidgetData?.length;

  useEffect(() => {
    if (point?.id) {
      if (
        !businessStore.servicesList ||
        businessStore.servicesList.length === 0
      ) {
        businessStore.initServicesList(point.id);
      }
      if (
        !businessStore.employeesWidgetData ||
        businessStore.employeesWidgetData.length === 0
      ) {
        businessStore.initEmployeesWidgetData(point.id);
      }
    }
  }, [point?.id]);

  return (
    <div className={styles.start__container}>
      {point && (
        <div className={styles.point__card}>
          <div className={styles.point__info}>
            <div className={styles.point__row}>
              <CircleImage imgSrc={point.logoUrl} imgSize={40} />
              <div className={styles.point__name}>{point.name}</div>
            </div>
            {point.description && (
              <div className={styles.point__description}>
                {point.description}
              </div>
            )}
            <div className={styles.point__address}>{point.address}</div>
          </div>
          <div className={styles.point__image}>
            <UniversalImage imgSrc={point.headerImageUrl} />
          </div>
        </div>
      )}
      <button className={styles.start__button} onClick={onSelectService}>
        <span className={styles.button__icon}>
          <ScissorsIcon />
        </span>
        <span className={styles.button__text}>Выбрать услугу</span>
        {servicesCount !== undefined && servicesCount > 0 && (
          <span className={styles.button__count}>{servicesCount}</span>
        )}
      </button>
      <button className={styles.start__button} onClick={onSelectEmployee}>
        <span className={styles.button__icon}>
          <PersonIcon />
        </span>
        <span className={styles.button__text}>Выбрать специалиста</span>
        {employeesCount !== undefined && employeesCount > 0 && (
          <span className={styles.button__count}>{employeesCount}</span>
        )}
      </button>
    </div>
  );
};

export const StepStart = observer(StepStartComponent);
